import React from 'react';
import { connect } from 'react-redux';

import Fade from '@material-ui/core/Fade';
import OrangeLinearProgress from './linearProgress';

import { _ } from '../../functions/translator';

class LoadingLevel extends React.Component {
  render () {
    let levelName = ''
    if (this.props.loadingLevelId) {
        let levelId = this.props.loadingLevelId.toString()
        levelName = this.props.levelsData[levelId].attributes.name
    }

    // Determine which loader to show
    const showLevelLoader = this.props.loadingLevel;
    const showWhatsAppLoader = this.props.loadingWhatsappObservations;
    const showLoader = showLevelLoader || showWhatsAppLoader;

    // Determine the loading message
    let loadingMessage = '';
    if (showWhatsAppLoader) {
        loadingMessage = _('Cargando Observaciones de WhatsApp') + '...';
    } else if (showLevelLoader) {
        if (this.props.whatsappObservationsMode) {
            loadingMessage = _('Cargando Observaciones de WhatsApp') + '...';
        } else {
            loadingMessage = _('Cargando') + ' ' + levelName + '...';
        }
    }

    return (
        <div>
            <Fade in={showLoader}>
                <div className='loading-container'>
                    <p>{loadingMessage}</p>
                    <OrangeLinearProgress/>
                </div>
            </Fade>
        </div>
    );
  }
}

function mapStateToProps( state ) {
    return {
        levelsData     : state.projectData.levels,
        loadingLevelId : state.loadingLevelId,
        loadingLevel   : state.switches.loadingLevel,
        loadingWhatsappObservations : state.switches.loadingWhatsappObservations,
        whatsappObservationsMode : state.switches.whatsappObservationsMode,
    }
}


export default connect(mapStateToProps)(LoadingLevel);
